import {useParams} from 'react-router-dom'
import {appsAPI} from '../../../../services/AppsService'
import {KTSVG} from '../../../../template/helpers'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useIntl} from 'react-intl'

const AMOCRM_CLIENT_ID = process.env.REACT_APP_AMOCRM_CLIENT_ID

const Domain = () => {
  const intl = useIntl()
  const {appId} = useParams()
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)

  return (
    <>
      <div className='row mb-5'>
        <label className='col-lg-4 fw-bolder text-gray-600 text-uppercase small'>
          {app?.crm === 'ONEC' ? (
            <>{intl.formatMessage({id: 'APPS.1C.INFO'})}</>
          ) : (
            <>{intl.formatMessage({id: 'APPS.CRMDOMAIN'})}</>
          )}
        </label>

        <div className='col-lg-8'>
          <div className='d-flex flex-stack'>
            <div className='d-flex col-8 fw-bolder text-gray-800 me-2'>{app?.crm_domain}</div>
            {app?.crm === 'AMOCRM' && (
              <OverlayTrigger
                placement='left'
                delay={{show: 50, hide: 50}}
                overlay={
                  <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                    {intl.formatMessage({id: 'APPS.AMOCRM.GRANTACCESS.BUTTON'})}
                  </Tooltip>
                }
              >
                <a
                  href={`https://amocrm.ru/oauth?client_id=${AMOCRM_CLIENT_ID}&mode=popup`}
                  target='_blank'
                  rel='noreferrer'
                  className='ms-1 text-end'
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen048.svg'
                    className='svg-icon svg-icon-2 svg-icon-gray-900 text-hover-primary me-1'
                  />
                </a>
              </OverlayTrigger>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export {Domain}
